var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c(_vm.componentName,_vm._b({tag:"Component",attrs:{"reportsData":_vm.reportsData,"dark":_vm.dark}},'Component',_vm.item,false),_vm._l((_vm.children),function(childItem,itemIndex){return _c('ReportComponent',{key:itemIndex,attrs:{"item":childItem,"reportsData":_vm.reportsData,"dark":_vm.dark}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }